import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  Output,
} from '@angular/core';
import { IProjectsListingVM } from '@app/core/state/entities/project/project-summary.viewmodel';
import { PageEvent, MatPaginatorModule } from '@angular/material/paginator';
import { ChangeDetectionStrategy, EventEmitter } from '@angular/core';
import { IProjectList } from '@app/project-index/list/list.component';
import { BehaviorSubject, combineLatest, map, Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import {FlexLayoutModule} from '@ngbracket/ngx-layout';
import { ListComponent } from '../list/list.component';
import { DebuggerComponent } from '../../shared/debugger/debugger.component';
import { DebuggerGroupComponent } from '../../shared/debugger-group/debugger-group.component';

export interface IHeadingFilter {
  subheading: string;
  filterFn: (projects: IProjectsListingVM[]) => IProjectsListingVM[];
}
@Component({
    selector: 'app-filter-list',
    templateUrl: './filter-list.component.html',
    styleUrls: ['./filter-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        DebuggerGroupComponent,
        DebuggerComponent,
        ListComponent,
        MatPaginatorModule,
        FlexLayoutModule,
        AsyncPipe,
    ]
})
export class FilterListComponent implements OnChanges {
  @Input()
  projects: IProjectsListingVM[] = [];

  @Input()
  headingFilters: IHeadingFilter[] | undefined;
  @Input()
  loading: boolean;

  @Input()
  total: number;

  @Output()
  openProject = new EventEmitter<string>();

  pageChange$$ = new BehaviorSubject<PageEvent>({
    pageSize: 10,
    pageIndex: 0,
    length: this.projects?.length ?? 0,
  });
  pageStats$: Observable<PageEvent> = this.pageChange$$.asObservable();
  ngOnChanges(changes: SimpleChanges): void {
    const projects = changes.projects?.currentValue;
    if (projects) {
      this.projects$$.next(projects);
      this.pageChange$$.next({
        ...this.pageChange$$.value,
        pageIndex: 0,
      }
      );
    }
  }
  projects$$ = new BehaviorSubject<IProjectsListingVM[]>([]);

  projects$: Observable<IProjectsListingVM[]>  = this.projects$$.asObservable();
  displayProjects$: Observable<IProjectsListingVM[]> = combineLatest([
    this.projects$,
    this.pageStats$,
  ]).pipe(
    map(([projects, pageChange]) => {
      // const pageIndex = Math.min(
      //   Math.floor(
      //     (projects.length ? projects.length - 1 : 0) / this.pageStats.pageSize
      //   ),
      //   this.pageStats.pageIndex
      // );
      const { pageIndex, pageSize } = pageChange;
      return projects.slice(pageIndex * pageSize, (pageIndex + 1) * pageSize);
    })
  );

  projectLists$: Observable<IProjectList[] | IProjectsListingVM[]> =
    this.displayProjects$.pipe(
      map(
        (projects) =>
          this.headingFilters?.map((filter) => ({
            subheading: filter.subheading,
            projects: filter.filterFn(projects),
          })) ?? projects
      )
    );

}
